import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { api, setToken } from "../lib/api";
import { useAuth } from "../lib/auth";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function GoogleCallback() {
    const nav = useNavigate();
    const { setSession } = useAuth();
    const done = useRef(false);

    useEffect(() => {
        if (done.current) return;
        done.current = true;
        const match = (window.location.hash || "").match(/session_id=([^&]+)/);
        const sessionId = match ? decodeURIComponent(match[1]) : "";
        if (!sessionId) {
            nav("/admin/login");
            return;
        }
        (async () => {
            try {
                const r = await api.post("/auth/google/session", { session_id: sessionId });
                setToken(r.data.token);
                setSession(r.data.user);
                nav("/admin");
            } catch (err) {
                const msg = err?.response?.data?.detail || "Google sign-in failed. Please try again.";
                nav("/admin/login", { state: { authMessage: msg } });
            }
        })();
    }, [nav, setSession]);

    return (
        <div className="bg-black text-white min-h-screen grid place-items-center" data-testid="google-callback">
            <p className="overline text-streetz-muted">Signing you in…</p>
        </div>
    );
}
